import { render, staticRenderFns } from "./AbaProgramacao.vue?vue&type=template&id=44a2bba8&scoped=true"
import script from "./AbaProgramacao.vue?vue&type=script&lang=js"
export * from "./AbaProgramacao.vue?vue&type=script&lang=js"
import style0 from "./AbaProgramacao.vue?vue&type=style&index=0&id=44a2bba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2bba8",
  null
  
)

export default component.exports